<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="modal-table">
    <div class="modal-header-wrapp">
      <div class="modal-header">
        <h2>{{ title }}</h2>
        <div class="close-wrapp" @click="modalClose">
          <div class="icon-close" />
        </div>
      </div>
      <div v-if="dataFileInfo && dataFileInfo.name && dataFileInfo.url" class="file-wrapper">
        <div class="file-name-wrapp">
          <div class="icon-file" />
          <!-- eslint-disable-next-line vue/no-parsing-error -->
          <span>{{ (isMobile && dataFileInfo.name.length <= 30 || !isMobile ? dataFileInfo.name : dataFileInfo.name.slice(0, 27) + '...') }}</span>
        </div>
        <a :href="dataFileInfo.url">
          <div class="button-down-wrapp">
            <div class="icon-download" />
            <span v-if="!isMobile">{{ $t('download_file') }}</span>
          </div>
        </a>
      </div>
    </div>
    <div class="modal-content">
      <div v-if="tableNote" class="table-note-wrapper">
        <markdown-it-vue class="table-note-text" :content="tableNote" :options="markDownOptions" />
      </div>
      <TableBicolor v-if="dataTable" :data-table="dataTable" :numeration="numeration" />
    </div>
  </div>
</template>

<script>
import MarkdownItVue from 'markdown-it-vue'
import TableBicolor from './TableBicolor.vue'
/**
 * Renders a modal with a table and title created by props
 * @example [none]
 */
export default {
  name: 'ModalTable',
  components: { MarkdownItVue, TableBicolor },
  props: {
    /**
     * Function for close the modal
     */
    modalClose: {
      type: Function,
    },
    /**
     * Title of the modal table
     */
    title: {
      type: String,
    },
    /**
     * Array with keys and values of the table
     */
    dataTable: {
      type: Array,
    },
    /**
     * Says if table has numeration or not
     */
    numeration: {
      type: Boolean,
    },
    /**
     * The name of the opened file
     */
    dataFileInfo: {
      type: Object,
    },
    /**
     * Table note printed in this modal before table
     */
    tableNote: {
      type: String,
    },
  },
  data() {
    return {
      markDownOptions: {
        markdownIt: {
          linkify: true
        },
        linkAttributes: {
          attrs: {
            target: '_blank',
            rel: 'noopener'
          }
        }
      },
    }
  },
  methods: {},
}
</script>

<style lang="stylus" scoped>
.modal-table
  z-index: 10
  display: flex
  flex-direction: column
  width: 100%
  height: 100%

  .modal-header-wrapp
    border-bottom: 1px solid $bcn-other-grey

    .file-wrapper
      display: flex
      justify-content: space-between
      padding: 0 vw(20px) vw(10px)

      .file-name-wrapp
        display: flex
        align-items: center
        gap: vw(5px)

        .icon-file
          m-icon("json-file", 22, #B4D7FF, false)

        span
          m-font-size(18, 26)
          font-weight: 400

          .mobile &
            m-font-size(14, 20)

      .button-down-wrapp
        display: flex
        align-items: center
        padding: vw(8px)
        padding-right: vw(15px)
        border-radius: 5px
        background-color: black
        gap: vw(5px)

        .mobile &
          padding: vw(4px)
          border-radius: 50%

        .icon-download
          m-icon("download-white", 16, #FFF)

        span
          m-font-size(14, 20)
          color: white
          font-weight: 400

    .modal-header
      display: flex
      justify-content: space-between
      align-items: center
      padding: 0 vw(10px) 0 vw(20px)
      width: 100%

      h2
        m-font-size(26, 34)
        font-weight: 600
        margin-block-start: vw(20px)
        margin-block-end: vw(20px)

        .mobile &
          m-font-size(22, 26)
          margin-block-start: vw(12px)
          margin-block-end: vw(12px)

      .close-wrapp
        display: flex
        padding: vw(6px)
        border: 1px solid $grey-dark
        border-radius: 50%
        cursor: pointer

        .mobile &
          padding: vw(3px)

        .icon-close
          m-icon("close", 20)

  .modal-content
    overflow-y: auto
    margin-top: vw(15px)
    margin-right: vw(20px)
    margin-left: vw(20px)

    .table-note-wrapper
      margin-bottom: vw(15px)

      .table-note-text
        m-font-size(16, 24)
        color: black
        font-weight: 300
        
        >>> a
          color: $corporate_color

    .table-wrapper
      display: flex
      min-height: 100px
</style>
